// The word after a count on the quote builder: "1 bag", "3 bags". A unit written short ("ea", "sf",
// "kg", "lb", "l", "gal"), "each" and a unit that already ends in "s" stay as they are ("3 ea").
const SAME = new Set(['ea', 'each', 'sf', 'kg', 'lb', 'l', 'gal']);

export function countWord(n, word) {
  const w = word == null ? '' : String(word);
  if (!w || Number(n) === 1 || SAME.has(w.toLowerCase()) || /s$/i.test(w)) return w;
  return `${w}s`;
}
